import {
  faAddressBook,
  faAngleDown,
  faAngleUp,
  faBriefcase,
  faBuilding,
  faCode,
  faFile,
  faHome,
  faMagnifyingGlass,
  faMoneyBill,
  faTableColumns,
  faUserGroup,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCategories } from "../../../apicalls";

const NavbarBtnMobileMega = ({ name, route, closeMenu }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const {
    isError: categoriesError,
    isLoading: categoriesLoading,
    data: allCategories,
  } = useQuery({
    queryKey: [`AllCategories`],
    queryFn: getCategories,
  });

  return (
    <>
      <button
        className="navbarBtnMobile"
        onClick={() => {
          setOpen(!open);
        }}
      >
        <FontAwesomeIcon icon={faMagnifyingGlass} />
        <p>Find Jobs</p>

        <div style={{ justifySelf: "flex-end" }}>
          <FontAwesomeIcon icon={open ? faAngleUp : faAngleDown} />
        </div>
      </button>

      {open && (
        <div
          style={{ backgroundColor: "#fff", width: "100%", paddingLeft: 30 }}
        >
          {allCategories?.map((e) => {
            return (
              <button
                className="megamenuItem"
                onClick={() => {
                  closeMenu();
                  navigate(`/jobs?category=${e.id}`);
                  setOpen(false);
                }}
              >
                <FontAwesomeIcon icon={faCircle} />
                <p>{e.name}</p>
              </button>
            );
          })}
        </div>
      )}
    </>
  );
};

export default NavbarBtnMobileMega;
